export default "__VITE_ASSET__DlDApKJs__"